import { Box, SxProps, Theme } from "@mui/material";
import katex from "katex";
import { useEffect, useRef } from "react";

interface IBybMathExpressions {
  formula: string;
  displayMode?: boolean;
  sx?: SxProps<Theme>;
}

const BybMathExpressions = ({ formula, displayMode = false, sx }: IBybMathExpressions) => {
  const containerRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      katex.render(formula, containerRef.current, {
        displayMode,
        throwOnError: false,
      });
    }
  }, [formula, displayMode]);

  return <Box component="span" ref={containerRef} sx={sx} />;
};

export default BybMathExpressions;
